import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";
import whatsappIcon from "../../assets/whatsapp-icon.png";

const Home = () => {
    const [productos, setProductos] = useState([]);
    const [productosAleatorios, setProductosAleatorios] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    useEffect(() => {
        fetchProductos();
    }, []);

    const fetchProductos = async () => {
        try {
            const response = await fetch("https://backend-vbfh.onrender.com/api/inventario");
            const data = await response.json();
            setProductos(data);
            
            // Barajar todos los productos aleatoriamente
            const productosBarajados = [...data].sort(() => 0.5 - Math.random());
            setProductosAleatorios(productosBarajados);
        } catch (error) {
            console.error("Error al obtener productos:", error);
        }
    };

    return (
        <div className="home-container">
            {/* Banner Promocional Animado */}
            <motion.section 
                className="home-banner"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                🚀 ¡Gran Promoción! Descuentos en herramientas seleccionadas. ¡Visítanos ahora!
            </motion.section>

            {/* Sección de Introducción con Animación */}
            <motion.section 
                className="home-intro"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
            >
                <h1>Bienvenido a <span>Distribuciones Aristizabal</span></h1>
                <p>
                Somos Distribuidores, atendemos el mercado nacional por medio de
                Mayoristas, Distribuidores e Importadores. Estamos en continuo
                crecimiento del portafolio con más de 500 referencias, dirigidas
                al sector ferretero, remodelación y constructor.
                Nuestros precios son competitivos y nos apasiona el servicio.. 🏗️🔧
                </p>
            </motion.section>

            {/* Carrusel de Productos */}
            <section className="home-carousel">
                <h2>Nuestros Productos</h2>
                <Slider {...settings}>
                    {productosAleatorios.map((producto, index) => (
                        <motion.div key={index} whileHover={{ scale: 1.05 }}>
                            <img 
                                src={`https://backend-vbfh.onrender.com/${producto.imagen}`} 
                                alt={producto.nombre} 
                            />
                            <div className="product-info">
                                <h3>{producto.nombre}</h3>
                                <p>{producto.descripcion}</p>
                            </div>
                        </motion.div>
                    ))}
                </Slider>
            </section>

            {/* Botón de WhatsApp Animado */}
            <motion.a 
                href="https://wa.me/573106031424" 
                className="whatsapp-button" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2 }}
                transition={{ duration: 0.3 }}
            >
                <img src={whatsappIcon} alt="WhatsApp" />
            </motion.a>
        </div>
    );
};

export default Home;